import {Component, ElementRef, OnInit, AfterViewInit} from "@angular/core";
import {NotificationService} from "../../../services/components/notification.service";
import {ConfigurationService} from "../../../services/configuration.service";
import {NotificationsWidgetConfigModel} from "../../../models/components/notifications-widget-config.model";

@Component({
    selector: "pcg-ng-notifications-widget",
    template: require('./notifications-widget.component.html')
})
export class NotificationsWidgetComponent implements OnInit, AfterViewInit {
    public constructor(
        private notificationService: NotificationService,
        private configService: ConfigurationService<NotificationsWidgetConfigModel>,
        private domElement: ElementRef,
    ) {
        this.configService.initialize(this.domElement.nativeElement.dataset);
    }

    private config: NotificationsWidgetConfigModel;

    public ngOnInit(): void {
        this.config = this.configService.config;
    }

    public ngAfterViewInit(): void {
        this.showErrorNotifications(this.config.errorMessages);
        this.showSuccessNotifications(this.config.successMessages);
    }

    public showErrorNotifications(notifications: Array<string>): void {
        if (!notifications) {
            return;
        }

        notifications.forEach(notification => this.notificationService.showError("", notification));
    }

    public showSuccessNotifications(notifications: Array<string>): void {
        if (!notifications) {
            return;
        }

        notifications.forEach(notification => this.notificationService.showSuccess("", notification));
    }
}
